import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageComponent } from './language.component';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateSharedLazyModule } from '../../modules/translate-shared-lazy.module';

@NgModule({
  declarations: [LanguageComponent],
  imports: [CommonModule, MatMenuModule, TranslateSharedLazyModule],
  exports: [LanguageComponent],
})
export class LanguageModule {}
